

import {
    toLakh,
    sumThis,
    numberWithCommas,
    toCurrency,
    sumOf,
    countOf,
    sumAndCountOf,
    showSum,
    showCount,
    showSumAndCount,
    percentChange,
    showBlank,
    changeClassTo,
    mobileNumber,
    panCardNumber,
    validEmail,
    adharNumber,
    allDirectQueries
  } from "../../commonFunctions";
  
  const ho009 = {
    label: "Printing Parameters",
    pageLabel: "Printing Parameters",
    starting: true,
    url: "ho009",
    pageType: "history",
    form: [
        {
            inputType: "displaytext",
            tab: "filterop",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Document",
            name: "",
            description: "Enter Document"
          },
          {
            inputType: "select",
            
            default: "",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            options: [
              {
                label: "Address Label",
                value: "AddressLabel"
              },
              {
                label: "Balance Certificate",
                value: "BalanceCertificate"
              },
              {
                label: "Cash Payment Voucher",
                value: "CashPaymentVoucher"
              },
              {
                label: "Cash Receipt Voucher",
                value: "CashReceiptVoucher"
              },
              {
                label: "Credit Clearing Voucher",
                value: "CreditClearingVoucher"
              },
              {
                label: "Customer Form 15G",
                value: "CustomerForm15G"
              },
              {
                label: "Customer Form 15H",
                value: "CustomerForm15H"
              },
              {
                label: "Customer Interest Certificate",
                value: "CustomerInterestCertificate"
              },
              {
                label: "Deposite A/c Opening Form",
                value: "Deposite_Ac_OpeningForm"
              },
              {
                label: "Dividend Warrant",
                value: "DividendWarrant"
              },
              {
                label: "FD Maturity Notice",
                value: "FDMaturityNotice"
              },
              {
                label: "FD Receipt",
                value: "FDReceipt"
              },
              {
                label: "Form 60",
                value: "Form60"
              },
              {
                label: "Form 61",
                value: "Form61"
              },
              {
                label: "Gold Receipt",
                value: "GoldReceipt"
              },
              {
                label: "Insurance Proposal Form",
                value: "InsuranceProposalForm"
              },
              {
                label: "Interest Certificate",
                value: "InterestCertificate"
              },
              {
                label: "Loan A/c opening Form",
                value: "Loan_Ac_openingForm"
              },
              {
                label: "OD Notice 1",
                value: "ODNotice1"
              },{
                label: "OD Notice 2",
                value: "ODNotice2"
              },{
                label: "OD Notice 3",
                value: "ODNotice3"
              },
              {
                label: "Overdue Notice 101",
                value: "OverdueNotice101"
              },
              {
                label: "Overdue Notice For Gold Loan",
                value: "OverdueNoticeForGoldLoan"
              },
              {
                label: "Overdue Notice Other",
                value: "Overdue Notice Other"
              },
              {
                label: "Passbook CC",
                value: "PassbookCC"
              },
              {
                label: "Passbook Deposit",
                value: "PassbookDeposit"
              },
              {
                label: "Passbook Loan",
                value: "PassbookLoan"
              },
              {
                label: "Passbook Title",
                value: "PassbookTitle"
              },
              {
                label: "Passbook Title(RD)",
                value: "Passbook Title(RD)"
              },
              {
                label: "Shares Certificate",
                value: "Shares Certificate"
              },

             ],
            placeHolder: "Document",
            name: "Document",
            description: "Enter Document"
          },
          {
            inputType: "checkbox",
            isRequired: true,
            default: "",
            widths: {
              parent: "col-sm-6",
              children: "col-sm-12"
            },
            placeHolder: "input with checkbox",
            label: "Logoo Print",
            name: "LogooPrint",
            description: "Logoo Print"
          },{
            inputType: "checkbox",
            isRequired: true,
            default: "",
            widths: {
              parent: "col-sm-6",
              children: "col-sm-12"
            },
            placeHolder: "input with checkbox",
            label: "Window Printing",
            name: "Window_Printing",
            description: "Window Printing"
          },
          {
            inputType: "displaytext",
            
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Print X",
            name: "",
            description: "Enter Print X" 
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "Print X",
            name: "PrintX",
            description: "Enter Print X"
          },
          {
            inputType: "checkbox",
            isRequired: true,
            default: "",
            widths: {
              parent: "col-sm-6",
              children: "col-sm-12"
            },
            placeHolder: "input with checkbox",
            label: "Verticle Passbook",
            name: "VerticlePassbook",
            description: "Verticle Passbook"
          },
          {
            inputType: "displaytext",
            tab: "filterop",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Print Y",
            name: "",
            description: "Enter Print Y"
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "Print Y",
            name: "PrintY",
            description: "Enter Print Y"
          },
          {
            inputType: "checkbox",
            isRequired: true,
            default: "",
            widths: {
              parent: "col-sm-6",
              children: "col-sm-12"
            },
            placeHolder: "input with checkbox",
            label: "Want Customer Copy",
            name: "WantCustomerCopy",
            description: "Want Customer Copy"
          },
          {
            inputType: "displaytext",
            tab: "filterop",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Page Heigth",
            name: "",
            description: "Enter Page Heigth"
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "Page Heigth",
            name: "PageHeigth",
            description: "Enter Page Heigth"
          },
          {
            inputType: "displaytext",
            tab: "filterop",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Logo File Name",
            name: "",
            description: "Enter Logo File Name"
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "Logo File Name",
            name: "LogoFileName",
            description: "Enter Logo File Name"
          },
          {
            inputType: "displaytext",
            tab: "filterop",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Page Width",
            name: "",
            description: "Enter Page Width"
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "Page Width",
            name: "PageWidth",
            description: "Enter Page Width"
          },
          {
            inputType: "displaytext",
            tab: "filterop",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Logo File Exten",
            name: "",
            description: "Enter Logo File Exten"
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "Logo File Exten",
            name: "LogoFileExten",
            description: "Enter Logo File Exten"
          },
          {
            inputType: "displaytext",
            tab: "filterop",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Row In Page",
            name: "",
            description: "Enter Row In Page"
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "Row In Page",
            name: "RowInPage",
            description: "Enter Row In Page"
          },
    ]
}

export default ho009;